import React from 'react';
import './index.scss';

import Logo from '../../assets/logo.svg';

const Title = () => {
	return (
		<div className='title-wrapper'>
			<img src={Logo} alt='logo' />
			<h4>NAILS & SPA</h4>
		</div>
	);
};

export default Title;
